import React, { useState } from 'react'
import { func, string } from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { isPassword } from 'utils/validate'
import { STATE_FETCHING, STATE_DONE, STATE_ERROR } from 'constants/stateTypes'
import { Input } from 'components/FormElements'
import ActionButton from 'components/uiElements/ActionButton'

require('./ChangePassword.scss')

const ChangePassword = ({ changePassword, changePasswordStatus, onClose }) => {
    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [passwordConfirm, setPasswordConfirm] = useState('')

    const passwordInvalid = !isPassword(newPassword)
    const changeDisabled = changePasswordStatus === STATE_FETCHING || passwordInvalid || newPassword !== passwordConfirm
    const { t } = useTranslation()

    return (
        <div className="ChangePassword">
            {changePasswordStatus === STATE_DONE ? (
                <div>
                    <h3>{t('login.changed')}</h3>
                    <div className="buttonsContainer">
                        <ActionButton onClick={onClose} type="secondary">
                            {t('login.close')}
                        </ActionButton>
                    </div>
                </div>
            ) : (
                <div>
                    <Input
                        type="password"
                        placeholder={t('login.placeholder current password')}
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        name="currentPassword"
                    />
                    <Input
                        type="password"
                        placeholder={t('login.placeholder new password')}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        name="password"
                    />
                    <p className="reqs">{t('login.requirements')}</p>
                    <Input
                        type="password"
                        placeholder={t('login.placeholder confirm your new password')}
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        name="passwordConfirm"
                        className={classNames({ error: newPassword && newPassword !== passwordConfirm })}
                    />
                    {changePasswordStatus === STATE_ERROR ? <p>{t('login.errMessage')}</p> : null}
                    <div className="buttonsContainer">
                        <ActionButton onClick={onClose} type="secondary">
                            {t('login.cancel')}
                        </ActionButton>
                        <ActionButton
                            onClick={() => changePassword(currentPassword, newPassword)}
                            disabled={changeDisabled}
                        >
                            {t('login.save changes')}
                        </ActionButton>
                    </div>
                </div>
            )}
        </div>
    )
}

ChangePassword.propTypes = {
    changePassword: func.isRequired,
    changePasswordStatus: string.isRequired,
    onClose: func.isRequired,
}

export default ChangePassword
